import * as React from 'react'
import autobind from 'autobind-decorator'
import {connect} from 'redux-scaffolding-ts'
import {withTranslation, WithTranslation} from 'react-i18next'
import {Icon} from 'antd'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'
import {ProjectMembersStore} from 'src/stores/projectmembers-store'
import SelectionInput from '../core/ui/form/selectionInput'

interface ProjectMemberEditorProps extends WithTranslation {
    companyId: string;
    projectId: string;
    disabled?: boolean;
    value?: number;
    onChange?: (value: number) => void;
    placeholder?: string;
    nullable?: boolean;
    minWidth?: number;
    multiple?: boolean;
}

interface ProjectMemberEditorState {
    employeeId: number | undefined;
}

@connect(["projectMembers", ProjectMembersStore])
class ProjectMemberEditor extends React.Component<ProjectMemberEditorProps, ProjectMemberEditorState> {

    private get membersStore() {
        return (this.props as any).projectMembers as ProjectMembersStore;
    }

    constructor(props: ProjectMemberEditorProps) {
        super(props);
        this.state = {
            employeeId: props.value
        }
        this.membersStore.changeUrlByProject(props.companyId, props.projectId);
    }

    static getDerivedStateFromProps(nextProps: ProjectMemberEditorProps, prevState: ProjectMemberEditorState) {
        if (nextProps.value !== prevState.employeeId) {
            return { employeeId: nextProps.value };
        }
        else return null;
    }

    @autobind
    private async getEmployees(searchQuery: string): Promise<QueryResult<ItemReference>> {
        var result = await this.membersStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            parameters: {
                "includeIds": [`${this.props.value}`],
            },
            take: 25,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }) || { count: 0, items: [] };

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.employeeId}`,
                title: `${o.employeeTitle}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    public render() {
        return (<SelectionInput
            content={(o) =>
                <div>
                    <Icon type="idcard" />
                    <span>&nbsp;{o ? o.title : ""}</span>
                </div>}
            searchable
            disabled={this.props.disabled}
            minWidth={this.props.minWidth}
            nullable={this.props.nullable}
            placeholder={this.props.placeholder}
            query={this.getEmployees}
            value={this.state.employeeId as any}
            multiple={this.props.multiple}
            showFooter
            onChange={(item: any) => { if (this.props.onChange) { this.props.onChange(item && item.id ? item.id : item as any || undefined) } }} />);
    }
}

export default withTranslation()(ProjectMemberEditor);